import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { ContactTypeDomain } from "@/main/models/request";

export abstract class IContactTypeApi {
	abstract getDomain(request: ContactTypeDomain): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getPublicDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
